import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { graphql } from 'react-apollo';
import Validator from 'validatorjs';
import _, { isEmpty, map } from 'lodash';
import {
  Form,
  Checkbox,
  Button,
  Modal,
  Icon,
  Message,
} from 'semantic-ui-react';

import createUserMutation from '../../graphql/createUserMutation';
import updateUserMutation from '../../graphql/updateUserMutation';
import Roles from '../../constants/roles';

class UserForm extends Component {
  constructor(props) {
    super(props);
    const { user } = props;
    this.state = {
      id: null || (user && parseInt(user.id, 10)),
      userName: '' || (user && user.username),
      email: '' || (user && user.email),
      locationInitials: '' || (user && user.locationInitials),
      active: user && user.active,
      errors: {},
      error: null,
      flashMessage: null,
      roleSet: [],
      legacySiteDisabled: false || (user && user.legacySiteDisabled),
      api_user: false || (user && user.roles.includes('api_user')),
      flat_rate_inquiry_viewer:
        false || (user && user.roles.includes('flat_rate_inquiry_viewer')),
      dealer_transaction_viewer:
        true || (user && user.roles.includes('dealer_transaction_viewer')),
      dealer_score_viewer:
        true || (user && user.roles.includes('dealer_score_viewer')),
      dealcheck_viewer:
        false || (user && user.roles.includes('dealcheck_viewer')),
      buyer_user: false || (user && user.roles.includes('buyer_user')),
      invoiceable: false || (user && user.roles.includes('invoiceable')),
      super_user: false || (user && user.roles.includes('super_user')),
      admin: false || (user && user.roles.includes('admin')),
      feature_flag_editor:
        false || (user && user.roles.includes('feature_flag_editor')),
      guarantee_admin_viewer:
        false || (user && user.roles.includes('guarantee_admin_viewer')),
      guarantee_admin_editor:
        false || (user && user.roles.includes('guarantee_admin_editor')),
      user_admin_editor:
        false || (user && user.roles.includes('user_admin_editor')),
      loss_prevention_viewer:
        false || (user && user.roles.includes('loss_prevention_viewer')),
      finance_admin_viewer:
        false || (user && user.roles.includes('finance_admin_viewer')),
      flat_rate_editor:
        false || (user && user.roles.includes('flat_rate_editor')),
      vehicle_creator:
        false || (user && user.roles.includes('vehicle_creator')),
      external_vehicle_enterer:
        false || (user && user.roles.includes('external_vehicle_enterer')),
      external_vehicle_approver:
        false || (user && user.roles.includes('external_vehicle_approver')),
      ds_fee_administration:
        false || (user && user.roles.includes('ds_fee_administration')),
      it_support: false || (user && user.roles.includes('it_support')),
      auction_location_editor:
        false || (user && user.roles.includes('auction_location_editor')),
      sa_rules_management:
        false || (user && user.roles.includes('sa_rules_management')),
    };
  }

  componentDidMount() {
    const { admin, super_user: superUser } = this.state;

    if ((!admin || admin === undefined) && (!superUser || superUser === undefined)) {
      this.setState({ roleSet: Roles.COMBINED_ROLES });
    } else if (!superUser || superUser === undefined) {
      this.setState({ roleSet: Roles.SUPER_USER_SPECIFIC_ROLES });
    } else if (!admin || admin === undefined) {
      this.setState({ roleSet: Roles.ADMIN_SPECIFIC_ROLES });
    }
  }

  checkRole = roleValue => {
    const { roleSet } = this.state;
    if (roleValue === 'super_user') {
      this.setState({
        roleSet: roleSet.filter(
          item => !Roles.SUPER_USER_SPECIFIC_ROLES.includes(item)
        ),
      });
    } else if (roleValue === 'admin') {
      this.setState({
        roleSet: roleSet.filter(
          item => !Roles.ADMIN_SPECIFIC_ROLES.includes(item)
        ),
      });
    }
    return roleValue;
  };

  addRole = roleValue => {
    if (roleValue === 'super_user') {
      this.setState({ roleSet: Roles.COMBINED_ROLES });
      Roles.COMBINED_ROLES.forEach(roleItem => this.setState({ [roleItem]: false }));
    } else if (roleValue === 'admin') {
      this.setState({ roleSet: Roles.ADMIN_SPECIFIC_ROLES });
      Roles.ADMIN_SPECIFIC_ROLES.forEach(roleItem => this.setState({ [roleItem]: false }));
    }
    return roleValue;
  };

  onChangeHandler = field => (event, data) => {
    const { target } = event;
    const value = data === undefined ? target.value : data.checked;
    if (data && data.checked) {
      this.checkRole(data.value);
    } else if (data && !data.checked) {
      this.addRole(data.value);
    }
    this.setState({ [field]: value });
    return value;
  };

  onSubmitHandler = () => {
    const {
      searchValue,
      searchQuery,
      createMutation,
    } = this.props;

    const validationRules = {
      email: 'required|email',
      userName: 'required',
    };

    const values = _.omit(this.state, [
      'error',
      'errors',
      'flashMessage',
      'roleSet',
    ]);
    const input = { user: { ...values } };

    const validation = new Validator(this.state, validationRules);
    if (validation.fails()) {
      this.setState({ ...validation.errors });
      return false;
    }
    createMutation({
      variables: { input },
    })
      .then(({ data }) => {
        const {
          adminCreateUser: { success, errorMessages },
        } = data;
        if (success) {
          this.setState({
            flashMessage: 'Successfully Created User',
          });
          searchQuery(searchValue);
          return true;
        }
        this.setState({
          error: errorMessages,
        });
        return false;
      })
      .catch(errorObj => {
        this.setState({
          error: `Error while creating user ${errorObj}`,
        });
        return false;
      });
    return true;
  };

  onEditHandler = () => {
    const {
      searchValue,
      searchQuery,
      updateMutation,
    } = this.props;

    const validationRules = {
      email: 'required|email',
      userName: 'required',
    };

    const values = _.omit(this.state, [
      'error',
      'errors',
      'flashMessage',
      'roleSet',
    ]);
    const input = { user: { ...values } };

    const validation = new Validator(this.state, validationRules);
    if (validation.fails()) {
      this.setState({ ...validation.errors });
      return false;
    }
    updateMutation({
      variables: { input },
    })
      .then(({ data }) => {
        const {
          adminUpdateUser: { success, errorMessages },
        } = data;
        if (success) {
          this.setState({
            flashMessage: 'Successfully Edited User',
          });
          searchQuery(searchValue);
          return true;
        }
        this.setState({
          error: errorMessages,
        });
        return false;
      })
      .catch(errorObj => {
        this.setState({
          error: `Error while editing user ${errorObj}`,
        });
        return false;
      });
    return true;
  };

  handleDismiss = () => {
    this.setState({ flashMessage: null });
  };

  handleDismissError = () => {
    this.setState({ error: null });
  };

  render() {
    const {
      isModalOpen,
      onCloseHandler,
      user,
    } = this.props;
    const {
      errors,
      error,
      flashMessage,
      roleSet,
      userName,
      email,
      locationInitials,
      active,
      legacySiteDisabled,
    } = this.state;

    // Get all state to handle dynamic props
    const { state } = this;

    return (
      <Modal
        closeIcon
        open={isModalOpen}
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>
          {isEmpty(user) ? 'Create User' : 'Edit User'}
        </Modal.Header>
        <Modal.Content image>
          <Modal.Description>
            {error && (
              <Message
                onDismiss={this.handleDismissError}
                content={error}
                negative
              />
            )}
            {flashMessage && (
              <Message
                onDismiss={this.handleDismiss}
                content={flashMessage}
                positive
              />
            )}
            <Form>
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.userName)}>
                  <label htmlFor='userName'>Username</label>
                  <input
                    id='userName'
                    name='userName'
                    value={userName}
                    onChange={this.onChangeHandler('userName')}
                  />
                  {errors.userName && (
                    <span style={{ color: 'red' }}>{errors.userName}</span>
                  )}
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.email)}>
                  <label htmlFor='email'>Email</label>
                  <input
                    id='email'
                    name='email'
                    value={email}
                    onChange={this.onChangeHandler('email')}
                  />
                  {errors.email && (
                    <span style={{ color: 'red' }}>{errors.email}</span>
                  )}
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='locationInitials'>Location Initials</label>
                  <input
                    id='locationInitials'
                    name='locationInitials'
                    value={locationInitials}
                    onChange={this.onChangeHandler('locationInitials')}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group>
                <Form.Field>
                  <label htmlFor='active'>Active</label>
                  <Checkbox
                    id='active'
                    name='active'
                    value='active'
                    checked={active}
                    onChange={this.onChangeHandler('active')}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor='legacySiteDisabled'>Legacy Site Disabled</label>
                  <Checkbox
                    id='legacySiteDisabled'
                    name='legacySiteDisabled'
                    value='legacySiteDisabled'
                    checked={legacySiteDisabled}
                    onChange={this.onChangeHandler('legacySiteDisabled')}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Roles</div>
                  {map(Roles.ROLES, (roleItem, index) => (
                    <Checkbox
                      key={index}
                      label={roleItem}
                      name={roleItem}
                      value={roleItem}
                      checked={state[roleItem]}
                      onChange={this.onChangeHandler(roleItem)}
                      disabled={roleSet.includes(roleItem)}
                    />
                  ))}
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color='green'
            onClick={isEmpty(user) ? this.onSubmitHandler : this.onEditHandler}
            inverted
          >
            <Icon name='checkmark' /> Submit
          </Button>
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

UserForm.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  searchValue: PropTypes.string,
  searchQuery: PropTypes.func,
  createMutation: PropTypes.func,
  updateMutation: PropTypes.func,
  user: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    username: PropTypes.string,
    email: PropTypes.string,
    locationInitials: PropTypes.string,
    active: PropTypes.bool,
    legacySiteDisabled: PropTypes.bool,
    roles: PropTypes.shape({
      includes: PropTypes.func,
    }),
  }),
};

export default compose(
  graphql(createUserMutation, { name: 'createMutation' }),
  graphql(updateUserMutation, { name: 'updateMutation' })
)(UserForm);
